.adminContainer {
	font-size: 0.25rem;
	padding: 0.5rem;
	h1 {
		margin-bottom: 0.25rem;
		font-size: 0.5rem;
		letter-spacing: normal;
	}
	button {
		margin-top: 1rem;
		width: 100%;
	}
	.inputGroup {
		margin-top: 0.5rem;

		input {
			margin-top: 0.1rem;
			font-size: 0.4rem;
			width: 100%;
		}
	}
}
